import { useMemo } from 'react'
import React from 'react'
import { AiOutlineInfoCircle } from 'react-icons/ai'

import { BodyPart } from '../../api/services/body_parts/types.ts'
import { FlatBodyMeasurement } from '../../api/services/dd_panel_body_measurements/types.ts'
import { setBodyPartsTableColumns } from '../../utils/bodyParts/bodyPartsTableSettings.tsx'
import Alert from '../common/Alert/Alert.tsx'
import Loader from '../common/Loader/Loader.tsx'
import Table from '../common/Table/Table.tsx'

const BodyPartsTable = ({
  loading,
  flatBodyMeasurements,
  bodyParts
}: {
  loading: boolean
  flatBodyMeasurements: FlatBodyMeasurement[]
  bodyParts: BodyPart[] | null
}) => {

  const columns = !bodyParts ? []:
    setBodyPartsTableColumns(bodyParts)


  const bodyMeasurementsWithAdditional = useMemo(() => {
    if (!flatBodyMeasurements?.length || !bodyParts?.length) return []

    return flatBodyMeasurements.map((measurement, index, array) => {
      const previousMeasurement =
        index < array.length - 1 ? array[index + 1] : array[index]

      const previousMeasurementValues = previousMeasurement as Record<
        string,
        string | number | boolean
      >

      const previousFields = bodyParts.reduce<
        Record<string, string | number | boolean>
      >((acc, { id }) => {
        const bodyPartKey = `body_part_${id}`
        acc[`previous_${id}`] = previousMeasurementValues[bodyPartKey]
        return acc
      }, {})

      return {
        ...measurement,
        ...previousFields
      }
    })
  }, [flatBodyMeasurements, bodyParts])

  return (
    <React.Fragment>
      {loading && <Loader label={'Pobieranie danych...'} />}

      {flatBodyMeasurements && flatBodyMeasurements.length > 0 && (
        <Table data={bodyMeasurementsWithAdditional} columns={columns} />
      )}

      {!loading && flatBodyMeasurements && flatBodyMeasurements.length === 0 && (
        <div>
          <Alert
            type="info"
            message="Brak danych"
            icon={<AiOutlineInfoCircle className="text-lg" />}
          />
        </div>
      )}
    </React.Fragment>
  )
}

export default React.memo(BodyPartsTable)
